export default __webpack_public_path__ + "static/media/ir.b7f68130.svg";